var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "searcher__box d-block d-md-none searcher__box--visible",
      attrs: { action: "/", method: "get" },
    },
    [
      _c(
        "label",
        { staticClass: "searcher__box__label", attrs: { for: "search" } },
        [
          _c("input", {
            staticClass: "searcher__box__input",
            attrs: { name: "s", id: "search", placeholder: "Czego szukasz?" },
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "searcher__box__button-mobile",
              attrs: { type: "submit" },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "mr-2",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "23",
                    height: "23",
                    viewBox: "0 0 23 23",
                  },
                },
                [
                  _c("g", [
                    _c("g", [
                      _c("g", [
                        _c("path", {
                          attrs: {
                            fill: "none",
                            stroke: "#93999c",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-miterlimit": "20",
                            "stroke-width": "1.4",
                            d: "M22 22l-5.6-5.6",
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("g", [
                        _c("path", {
                          attrs: {
                            fill: "none",
                            stroke: "#93999c",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-miterlimit": "20",
                            "stroke-width": "1.4",
                            d: "M10 1a9 9 0 0 1 9 9 9 9 0 0 1-9 9 9 9 0 0 1-9-9 9 9 0 0 1 9-9z",
                          },
                        }),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }